export default __webpack_public_path__ + "assets/img/avatar-9.651c408.png";